export const RESOURCE_TYPE_CONNECT_GENERAL = 'CONNECT_GENERAL';
